// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3qn2a","footer":"ChangeClinic_footer__2KXQD"};